var _this = this;
// 获取cookie
window.getCookie = function (cname) {
  var result = null;
  var myCookie = '' + document.cookie + ';';
  var searchName = '' + cname + '=';
  var startOfCookie = myCookie.indexOf(searchName);
  var endOfCookie;
  if (startOfCookie !== -1) {
    startOfCookie += searchName.length;
    endOfCookie = myCookie.indexOf(';', startOfCookie);
    result = myCookie.substring(startOfCookie, endOfCookie);
  }
  return result;
};
var isBrowser = typeof window === 'object';
var state = isBrowser ? {
  isBrowser: true,
  browserLang: window.navigator.language || window.navigator.userLanguage || '',
  localStorage: window.localStorage,
  staticBaseUrl: window.feConfig.common.staticBaseUrl,
  feConfig: window.feConfig,
  YXT_SWL_COLOR: window.YXT_SWL_COLOR || getCookie('__yxtswlcolor_')
} : {
  // 是浏览器环境
  isBrowser: false,
  browserLang: '',
  localStorage: {
    token: '',
    // node环境下的token凭证
    orgId: '',
    // node下的机构ID
    timezoneMaxFailTimes: 3,
    // 最大频繁连续失败次数
    getItem: function getItem(key) {
      return _this[key];
    },
    setItem: function setItem(key, val) {
      _this[key] = typeof val === 'string' ? val : JSON.stringify(val);
    }
  },
  i18n_instance: null
};
/**
 * node项目需要use yxt-i18n 用于设置环境初始值
 * @param {*} param0
 * @returns
 */
export var setState = function setState(_ref) {
  var browserLang = _ref.browserLang,
    localStorage = _ref.localStorage;
  if (state.isBrowser) return;
  state.browserLang = browserLang;
  for (var key in localStorage || {}) {
    state.localStorage.setItem(key, localStorage[key]);
  }
};
export default state;